import React from 'react'

const TenderOverivew = React.lazy(() => import('./views/tender-overview/TenderOverview'))
const TenderView = React.lazy(() => import('./views/tender-view/TenderView'))
const AdminDashboard = React.lazy(() => import('./views/admin-overview/AdminDashboard'))

const routes = [
  //{ path: '/', exact: true, name: 'Home' },
  {
    path: '/tender-overview',
    name: 'Tender Overview',
    element: TenderOverivew,
  },
  {
    path: '/tender-overview/tender-detail-view/:tenderId',
    name: 'Tender Detail View',
    element: TenderView,
  },
  { path: '/admin-overview', name: 'Admin Dashboard', element: AdminDashboard },
]

export default routes
